import { MensajesUsuario } from 'src/app/shared/enumeraciones/mensajes-usuario.enum';
import { AlertsService } from './../../../../../../shared/services/alerts.service';
import { AccionesRntType } from "src/app/shared/enumeraciones/acciones-rnt.enum";
import { AccionesRntEntry } from "src/app/shared/entrys/acciones-rnt.entry";
import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { NgbModal, NgbPopover } from "@ng-bootstrap/ng-bootstrap";
import { ModalEstablecimientoComponent } from "src/app/components/core/layouts/modal-establecimiento/modal-establecimiento.component";
import { EstablecimientoEntry } from "src/app/shared/entrys/establecimiento.entry";
import { EstablecimientoComercioService } from "./establecimiento-comercio.service";
import { Router } from "@angular/router";
import { AuthService } from "src/app/shared/services/auth.service";
import { RNTPrestadorEntry } from "src/app/shared/entrys/rnt-prestador.entry";
import { DataSharedService } from "src/app/shared/services/data-shared.service";
import { DatoSolicitudSharedModel } from "src/app/shared/models/dato-solicitud-shared.model";
import {
  DatoPaginadoModel,
  Paging,
} from "src/app/shared/models/dato-paginado.model";
import { EstadoRnt } from "src/app/shared/entrys/estado-contador-establecimiento.entry";
import { EstadoContadorEstablecimientoModel } from "src/app/shared/models/estado-contador-establecimiento.model";
import { TipoPrestadorId } from "../../../../../../shared/enumeraciones/tipo-prestador-id.enum";
import { TipoPrestador } from "src/app/shared/enumeraciones/tipo-prestador.enum";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { TipoSolicitudEntry } from "src/app/shared/entrys/tipo-solicitud.entry";
import { SubCategoriaEntry } from "src/app/shared/entrys/sub-categoria.entry";
import { CamaraComercioEntry } from "src/app/shared/entrys/camara-comercio";
import { EstadoSolicitudEntry } from "src/app/shared/entrys/estado-solicitud.entry";
import { EstadosRNTEntry } from "src/app/shared/entrys/estados-rnt-entry";
// tslint:disable-next-line:max-line-length
import { ModalSeleccionTipoRntComponent } from "src/app/components/core/layouts/modal-seleccion-tipo-rnt/modal-seleccion-tipo-rnt.component";
import { TipoRnt } from "src/app/shared/enumeraciones/tipo-rnt.enum";
import { JsonPipe } from "@angular/common";
import { EstadosSolicitud } from "src/app/shared/enumeraciones/estados-solicitud.enum";
import { AyudasService } from "src/app/components/contenido/containers/ayudas/ayudas.service";
import { environment } from "src/environments/environment";
import { EstadosRnt } from "src/app/shared/enumeraciones/estados-rnt.enum";
import { RNTPrestadorModel } from "src/app/shared/models/rnt-prestador.models";
import { TipoSolicitud } from "src/app/shared/enumeraciones/tipo-solicitud.enum";
import { EnviromentGlobalService } from "src/app/shared/services/enviroment-global.service";
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { SubcategoriaService } from 'src/app/components/core/containers/bandeja-principal/administrador/configuracion/subcategoria/subcategoria.service';
import { ModalCambioInmuebleComponent } from "src/app/components/core/layouts/modal-cambio-inmueble/modal-cambio-inmueble.component";

import {
  ConfirmarRespuestaModel,
  TipoConfirmacionModalType,
  ConfirmarRespuestaType,
} from "src/app/shared/models/confirmar-respuesta.model";
import { ModalConfirmarRespuestaComponent } from "src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component";
import { SancionesPersonasService } from '../../administrador/gestion/sanciones-personas/sanciones-personas.service';
import { ModalValidarRenovacionComponent } from 'src/app/components/core/layouts/modal-validar-renovacion/modal-validar-renovacion.component';

@Component({
  selector: "app-establecimiento-comercio",
  templateUrl: "./establecimiento-comercio.component.html",
  styleUrls: ["./establecimiento-comercio.component.scss"],
})
export class EstablecimientoComercioComponent implements OnInit {
  puedeCrearRnt = true;
  establecimientos: Array<EstablecimientoEntry>;
  rnts: Array<RNTPrestadorEntry>;
  headersRnt: Array<string>;
  selectEstablecimiento: EstablecimientoEntry;
  dataTabla: DatoPaginadoModel;
  contadorEstados: Array<EstadoContadorEstablecimientoModel>;
  public isCollapsed = true;
  accionesRnt: Array<AccionesRntEntry>;
  rol_nocomerciante = false;
  rol_comerciante = false;
  rol_plataforma: boolean;
  estado_solicitud_devuelto = EstadosSolicitud.Devuelto;
  cargaPantalla: boolean;
  descripcion_encabezado: string;
  // Aux Vehículos
  accionVehiculo: AccionesRntEntry;
  rutaAmazon;

  // filtros
  filtro: FormGroup;
  tipoSolicitudLista: Array<TipoSolicitudEntry>;
  subCategoriasLista: Array<SubCategoriaEntry>;
  camarasLista: Array<CamaraComercioEntry>;
  estadoSolicitudLista: Array<EstadoSolicitudEntry>;
  estadoRNTLista: Array<EstadosRNTEntry>;
  solicitudSinRadicar = EstadosSolicitud.EnProceso;
  camaraUrl: string;
  numeroRNT: string;
  numeroEstablecimiento: string;
  camara: string;
  categoria: string;
  estadoRNT: string;
  tipo: string;
  estadoSolicitud: string;
  verificacionGuia: number;
  paginaActual: number;
  mensajeEliminacion: string;

  constructor(
    private router: Router,
    private modalService: NgbModal,
    private establecimientoComercioService: EstablecimientoComercioService,
    private authService: AuthService,
    private dataSharedService: DataSharedService,
    public fb: FormBuilder,
    public ayudaService: AyudasService,
    private enviromentGlobalService: EnviromentGlobalService,
    private subcategoriaService: SubcategoriaService,
    private alertService: AlertsService,
    private sancionesPersonasService: SancionesPersonasService
  ) {
    this.dataTabla = {
      paging: {} as Paging,
    } as DatoPaginadoModel;
    this.rol_comerciante = authService.getRolDetalleUser() === TipoPrestador.Comerciante;
    this.rol_nocomerciante = authService.getRolDetalleUser() === TipoPrestador.Guia;
    //this.rol_plataforma = authService.getRolDetalleUser() === TipoPrestadorId.NoComerciante;


    this.accionVehiculo = { ruta_url: "vehiculos" } as AccionesRntEntry;
    this.cargaPantalla = true;
    this.paginaActual = 1;
    this.rutaAmazon = enviromentGlobalService.amazonImage;
  }

  ngOnInit() {
    console.log("Version: V.0.3.1");
    this.reset_LocalStorage();
    this.createForm();
    this.consultaTabla(1);
    this.headersRnt = [
      "Número RNT",
      "Tipo RNT",
      "Nombre del establecimiento",
      "Cámara de Comercio",
      "Dirección",
      "Sub categoría",
      "Fecha de Inscripción",
      "Último Año Renovado",
      "Estado de RNT",
      "Tipo Solicitud: Estado Solicitud",
      "Radicado",
      "Acciones",
    ];
    this.establecimientoComercioService
      .getEstablecimientoContadorPorUsuario(this.authService.getUserNameToken())
      .subscribe((resultado) => {
        if (resultado.result) {
          this.contadorEstados = resultado.data as Array<EstadoContadorEstablecimientoModel>;
          this.contadorEstados = this.contadorEstados
            .map((dato) => {
              dato.descripcion = dato.descripcion.toLowerCase();
              switch (dato.estado_rnt_id) {
                case EstadoRnt.A:
                  dato.imagen = "/assets/images/activa.png";
                  dato.cssClass = "activa";
                  dato.orden = 2;
                  break;
                case EstadoRnt.C:
                  dato.imagen = "/assets/images/cancelada.png";
                  dato.cssClass = "cancelada";
                  dato.orden = 4;
                  break;
                case EstadoRnt.D:
                  dato.imagen = "/assets/images/devueltas.png";
                  dato.cssClass = "devuelto";
                  dato.orden = 1;
                  break;
                case EstadoRnt.S:
                  dato.imagen = "/assets/images/suspendida.png";
                  dato.cssClass = "suspendida";
                  dato.orden = 3;
                  break;
              }
              return dato;
            })
            .sort((or1, or2) => (or1.orden > or2.orden ? 1 : -1));
        }
      });
    this.authService.logoCamaraUser.subscribe((resultado) => {
      if (resultado.result && resultado.data) {
        this.camaraUrl = `${this.rutaAmazon}/${resultado.data.ruta}/${resultado.data.nombre_archivo}`;
      }
    });
    this.establecimientoComercioService
      .getParametro({
        parametro_id: "BANDEJA_PRESTADOR",
        agrupacion: "TEXTOS_INTERFAZ",
        auxiliar: "1",
      })
      .subscribe((resultado) => {
        if (resultado.result) {
          this.descripcion_encabezado = resultado.data;
        }
      });
    this.consultarListas();

    this.getMensajeEliminacion();
    this.validarSancionPersona();
  }

  onOpenModal() {
    const modalRef = this.modalService.open(ModalSeleccionTipoRntComponent, {
      centered: true,
      backdropClass: "light-blue-backdrop",
    });
    modalRef.componentInstance.verificacionGuia = this.verificacionGuia;
    modalRef.result.then((respuesta: TipoRnt) => {
      switch (respuesta) {
        case TipoRnt.Inmuebles:
          this.loadDataSharedModule(TipoSolicitud.Inscripcion, TipoRnt.Inmuebles);
          break;
        case TipoRnt.PlataformaDigitales:
          this.loadDataSharedModule(TipoSolicitud.Inscripcion, TipoRnt.PlataformaDigitales);
          break;
        default:
          this.cargarEstablecimientos(respuesta);
          break;
      }


      console.log(respuesta)
    });
  }

  loadDataSharedModule(tiposolicitud: number, tipornt: number){
    this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
      tipo_solicitud: tiposolicitud,
      data:{estado_rnt_id:EstadosRnt.SinEstado},
      tipo_rnt: tipornt,
    });
    this.router.navigate(["solicitud"]);
  }

  cargarEstablecimientos(tipo_rnt: TipoRnt) {
    if (
      this.authService.getRolDetalleUser() === TipoPrestador.Comerciante &&
      tipo_rnt === TipoRnt.Guia
    ) {
      this.dataSharedService.sharedData(<any>{
        tipo_solicitud: TipoSolicitud.Inscripcion,
        tipo_rnt,
        estado_rnt_id: EstadosRnt.SinEstado
      });
      this.router.navigate(["solicitud"]);
    } else {
      this.establecimientoComercioService
        .getEstablecimientoPorUsuario(
          { usuario: this.authService.getUserNameToken() },
          1
        )
        .subscribe((resultado) => {
          if (resultado.result) {
            if (tipo_rnt !== TipoRnt.Guia && tipo_rnt !== TipoRnt.PlataformaDigitales) {
              const modalRef = this.modalService.open(
                ModalEstablecimientoComponent,
                {
                  centered: true,
                  size: "lg",
                  backdropClass: "light-blue-backdrop",
                  windowClass: "modal-customer-xl",
                }
              );
              const data_paginado = resultado.data as DatoPaginadoModel;
              this.establecimientos = data_paginado.items;
              modalRef.componentInstance.datoPaginadoModel = data_paginado;
              modalRef.result.then((respuestaModal: EstablecimientoEntry) => {
                this.establecimientoComercioService
                  .create({
                    ...respuestaModal,
                    tipo_rnt_id: tipo_rnt,
                  } as EstablecimientoEntry)
                  .subscribe((resultadoDataSelect) => {
                    if (resultadoDataSelect.result) {
                      console.log('%cHello establecimiento-comercio.component.ts line:233 ', 'background: green; color: white; display: block;', resultadoDataSelect.data);
                      this.dataSharedService.sharedData(<
                        DatoSolicitudSharedModel
                      >{
                        data: resultadoDataSelect.data as EstablecimientoEntry,
                        tipo_solicitud: TipoSolicitud.Inscripcion,
                        tipo_rnt: tipo_rnt,
                      });
                      this.router.navigate(["solicitud"]);
                    }
                  });
              });
            } else {
              this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
                tipo_solicitud: TipoSolicitud.Inscripcion,
                tipo_rnt: tipo_rnt,
                data:{estado_rnt_id:EstadosRnt.SinEstado},
              });
              this.router.navigate(["solicitud"]);
            }
          }
        });
    }
  }

  onPaginadoEstablecimiento() {}

  onPaginado(value: number) {
    this.consultaTabla(value);
    this.paginaActual = value;
  }

  onLoadAcciones(rntPrestadorEntry: RNTPrestadorEntry) {
    this.establecimientoComercioService
      .getAccionesPorRnt(rntPrestadorEntry)
      .subscribe((resultado) => {
        if (resultado.result) {
          this.accionesRnt = resultado.data as Array<AccionesRntEntry>;
        }
      });
  }

  onDismissAcciones() {
    this.accionesRnt = [];
  }

  onVerificacion() {
    if(!this.puedeCrearRnt){
      this.getParam({
        parametro_id: 'ADVERTENCIA_PRESTADOR_SANCION_NO_PERMITE_CREAR_RNT',
        agrupacion: 'VALIDACIONES',
        auxiliar: 1
      },false);
    }else{  
      this.establecimientoComercioService
      .verificarGuia()
      .subscribe((resultado) => {
        this.verificacionGuia = resultado.data;

        this.onOpenModal();
      });
    }
  }

  onAcciones(
    rntPrestadorEntry: RNTPrestadorModel,
    accionesRnt: AccionesRntEntry
  ) {
    switch (accionesRnt.ruta_url) {
      case AccionesRntType.ExpedirCertificado:
        this.establecimientoComercioService
          .getExpedirCertificadoPorRnt(rntPrestadorEntry)
          .subscribe((resultado) => {
            const url = window.URL.createObjectURL(resultado);
            window.open(url);
          });
        break;
      case AccionesRntType.Reactivacion:
        this.validarSubcategoriaBloqueada(rntPrestadorEntry.sub_categoria_id, 
                                          TipoSolicitud.Reactivacion, 
                                          {
                                            ...rntPrestadorEntry,
                                            es_devuelta: (accionesRnt.accion !=='Solicitud de Reactivación+Renovación')
                                          },
                                          accionesRnt);
        break;
      case AccionesRntType.Cancelacion:
        this.validarSubcategoriaBloqueada(rntPrestadorEntry.sub_categoria_id, TipoSolicitud.Cancelacion, rntPrestadorEntry, accionesRnt);
        break;
      case AccionesRntType.Suspension:
        this.validarSubcategoriaBloqueada(rntPrestadorEntry.sub_categoria_id, TipoSolicitud.Suspension, rntPrestadorEntry, accionesRnt);
        break;
      case AccionesRntType.Edicion:
        this.validarSubcategoriaBloqueada(rntPrestadorEntry.sub_categoria_id, TipoSolicitud.Actualizacion, rntPrestadorEntry, accionesRnt);
        break;
      case AccionesRntType.ReporteInscripcion:
        this.establecimientoComercioService
          .getExpedirCertificadoRegistroPorRnt(rntPrestadorEntry)
          .subscribe((resultado) => {
            const url = window.URL.createObjectURL(resultado);
            window.open(url);
          });
        break;
      case AccionesRntType.Inscripcion:
        this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
          data: rntPrestadorEntry,
          tipo_solicitud: TipoSolicitud.Inscripcion,
          estado_solicitud: rntPrestadorEntry.estado_solicitud_id,
          tipo_rnt: rntPrestadorEntry.tipo_rnt_id,
        });
        this.router.navigate(["solicitud"]);
        break;
      case AccionesRntType.Renovacion:
        this.validarSubcategoriaBloqueada(rntPrestadorEntry.sub_categoria_id, TipoSolicitud.Renovacion, rntPrestadorEntry, accionesRnt);
        break;
      case AccionesRntType.Arrendatario:
        this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
          data: rntPrestadorEntry,
        });
        this.router.navigate(["arrendatario"]);
        break;
      case AccionesRntType.Notificaciones:
        this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
          data: rntPrestadorEntry,
          tipo_rnt: rntPrestadorEntry.tipo_rnt_id,
        });
        this.router.navigate(["notificacion"]);
        break;
      case AccionesRntType.DetalleSolicitud:
        this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
          data: rntPrestadorEntry,
          tipo_rnt: rntPrestadorEntry.tipo_rnt_id,
        });
        this.router.navigate(["detalle-solicitud/establecimientos"]);
        break;
      case AccionesRntType.Vehiculos:
        this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
          data: rntPrestadorEntry,
        });
        this.router.navigate(["vehiculos"]);
        break;
      case AccionesRntType.ReactivacionAnticipada:
        this.validarSubcategoriaBloqueada(rntPrestadorEntry.sub_categoria_id, TipoSolicitud.ReactivacionAnticipada, rntPrestadorEntry, accionesRnt);
        break;
      case AccionesRntType.Eliminacion:
        const idSolicitud = rntPrestadorEntry.solicitud_id;
        const modalRef = this.modalService.open(ModalConfirmarRespuestaComponent, { centered: true });
        const confirmarRespuesta = {} as ConfirmarRespuestaModel;
        confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
        confirmarRespuesta.message = this.mensajeEliminacion;
        modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
        modalRef.result.then(() => {
          this.establecimientoComercioService.eliminarSolicitud(idSolicitud).subscribe((response) => {
            if(response.result){
              this.alertService.success(
                MensajesUsuario.SolicitudEliminada,
                null,
                null
              );

              this.consultaTabla(this.paginaActual);
            } else{
              this.alertService.error(
                MensajesUsuario.Errorgeneral,
                null,
                null
              );
            }
          });
        });
    }
  }

  onAnotacion(rntPrestadorEntry: RNTPrestadorEntry) {
    this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
      data: rntPrestadorEntry,
    });
    this.router.navigate(["anotacion"]);
  }

  // filtros
  consultarListas() {
    this.establecimientoComercioService
      .getTipoSolicitud()
      .subscribe((resultado) => {
        if (resultado) {
          this.tipoSolicitudLista = resultado.data as Array<TipoSolicitudEntry>;
        }
      });

    this.establecimientoComercioService
      .getSubCategorias()
      .subscribe((resultado) => {
        if (resultado) {
          this.subCategoriasLista = resultado.data as Array<SubCategoriaEntry>;
        }
      });

    this.establecimientoComercioService.getCamaras().subscribe((resultado) => {
      if (resultado) {
        this.camarasLista = resultado.data as Array<CamaraComercioEntry>;
      }
    });

    this.establecimientoComercioService
      .getEstadosRNT()
      .subscribe((resultado) => {
        if (resultado) {
          this.estadoRNTLista = resultado.data as Array<EstadosRNTEntry>;
        }
      });

    this.establecimientoComercioService
      .getEstadosSolicitud()
      .subscribe((resultado) => {
        if (resultado) {
          this.estadoSolicitudLista = resultado.data as Array<EstadoSolicitudEntry>;
        }
      });
  }

  createForm() {
    this.filtro = this.fb.group({
      numeroRNT: [null, Validators.required],
      numeroEstablecimiento: [null, Validators.required],
      camara: [null, Validators.required],
      categoria: [null, Validators.required],
      estadoRNT: [null, Validators.required],
      tipo: [null, Validators.required],
      estadoSolicitud: [null, Validators.required],
    });
  }

  llenarVariablesConsulta() {
    this.numeroRNT = this.filtro.get("numeroRNT").value;
    this.numeroEstablecimiento = this.filtro.get("numeroEstablecimiento").value;
    this.camara = this.filtro.get("camara").value;
    this.categoria = this.filtro.get("categoria").value;
    this.estadoRNT = this.filtro.get("estadoRNT").value;
    this.tipo = this.filtro.get("tipo").value;
    this.estadoSolicitud = this.filtro.get("estadoSolicitud").value;
  }

  enviarForm() {
    this.paginaActual = 1;
    this.llenarVariablesConsulta();
    this.consultaTabla(1);
  }

  consultaTabla(value: number) {
    this.establecimientoComercioService
      .getRnt(
        {
          codigo_rnt: this.numeroRNT,
          establecimiento: this.numeroEstablecimiento,
          codigo_camara: this.camara,
          sub_categoria_id: this.categoria,
          estado_rnt_id: this.estadoRNT,
          tipo_solicitud_id: this.tipo,
          estado_solicitud_id: this.estadoSolicitud,
        },
        value
      )
      .subscribe((resultado) => {
        if (resultado.result) {
          this.cargaPantalla = false;
          if (resultado.data.items != 0) {
            this.dataTabla = resultado.data as DatoPaginadoModel;
            this.rnts = this.dataTabla.items as Array<RNTPrestadorEntry>;
          } else {
            this.dataTabla.items = [];
          }
        }
      });
  }

  limpiar() {
    this.filtro.reset();
    this.llenarVariablesConsulta();
    this.consultaTabla(1);
    this.paginaActual = 1;
  }

  reset_LocalStorage(){
    localStorage.removeItem("keyCategoria");
  }

  validarSubcategoriaBloqueada(sub_categoria_id: number, tipoSolicitud: number,
    rntPrestadorEntry: RNTPrestadorModel,
    accionesRnt: AccionesRntEntry) {
    this.subcategoriaService.obtenerTipoSolicitud(sub_categoria_id)
			.subscribe(resultado => {
				if (resultado.result) {
          var item = resultado.data.filter((feature : any) => feature.tiposolicitudid == tipoSolicitud);
          if(item.length === 0){
            this.abrirModalMensajeRNT(sub_categoria_id);
            return;
          }
          switch (accionesRnt.ruta_url) {
            case AccionesRntType.Reactivacion:
              //SI EL ESTADO RNT ES SUSP POR NO RENOVAR SE REDIRIGE A SOLICITUD R+R
              this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
                data: rntPrestadorEntry,
                tipo_solicitud: TipoSolicitud.Reactivacion,
                estado_solicitud: rntPrestadorEntry.estado_solicitud_id,
                tipo_rnt: rntPrestadorEntry.tipo_rnt_id
              });
              this.router.navigate(["otra-solicitudes"]);
              break;
            case AccionesRntType.Cancelacion:
              this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
                data: rntPrestadorEntry,
                tipo_solicitud: TipoSolicitud.Cancelacion,
                estado_solicitud: rntPrestadorEntry.estado_solicitud_id,
                tipo_rnt: rntPrestadorEntry.tipo_rnt_id,
              });
              this.router.navigate(["otra-solicitudes"]);
              break;
            case AccionesRntType.Suspension:
              this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
                data: rntPrestadorEntry,
                tipo_solicitud: TipoSolicitud.Suspension,
                estado_solicitud: rntPrestadorEntry.estado_solicitud_id,
                tipo_rnt: rntPrestadorEntry.tipo_rnt_id,
              });
              this.router.navigate(["otra-solicitudes"]);
              break;
            case AccionesRntType.Edicion:
                this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
                  data: rntPrestadorEntry,
                  tipo_solicitud: TipoSolicitud.Actualizacion,
                  estado_solicitud: rntPrestadorEntry.estado_solicitud_id,
                  tipo_rnt: rntPrestadorEntry.tipo_rnt_id,
                });
                this.router.navigate(["solicitud"]);
              break;
            case AccionesRntType.Renovacion:
              this.establecimientoComercioService
                .getParametro({
                  parametro_id: "EXONERACION_FONTUR_MUNICIPIO",
                  agrupacion: "VALIDACIONES",
                  auxiliar: "1",
                })
                .subscribe((resultado) => {
                  if (resultado.result) {
                    rntPrestadorEntry.excepcion_municipio_pago_fontur = resultado.data.startsWith(
                      rntPrestadorEntry.municipio_id                      
                    );
                    if(rntPrestadorEntry.tipo_rnt_id==2){
                      rntPrestadorEntry.excepcion_municipio_pago_fontur =true;
                    } 
                    this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
                      data: rntPrestadorEntry,
                      tipo_solicitud: TipoSolicitud.Renovacion,
                      estado_solicitud: rntPrestadorEntry.estado_solicitud_id,
                      tipo_rnt: rntPrestadorEntry.tipo_rnt_id,
                    });
                    this.router.navigate(["solicitud"]);
                  }
                });
              break;
            case AccionesRntType.ReactivacionAnticipada:
              this.abrirModalDeConfirmacionParaReactivacionAnticipada(rntPrestadorEntry);
              break;
          }
				}
			});
	}

  abrirModalMensajeRNT(sub_categoria_id: number) {
    this.subcategoriaService.obtenerMensajeDenegacion(sub_categoria_id)
    .subscribe(resultado => {
      if (resultado.result) {
        console.log(resultado.data);
        const modalRef = this.modalService.open(ModalCambioInmuebleComponent, {
          centered: true,
        });
        const confirmarRespuesta = {} as ConfirmarRespuestaModel;
        confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
        confirmarRespuesta.tipoConfirmacionModalType = TipoConfirmacionModalType.Alerta;
        // tslint:disable-next-line:max-line-length
        confirmarRespuesta.message = resultado.data;
        confirmarRespuesta.buttonTextAlert = "Continuar";
        modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
      }
    });
  }

  private abrirModalDeConfirmacionParaReactivacionAnticipada(rntPrestadorEntry: RNTPrestadorModel): void {
    this.establecimientoComercioService
      .getParametro({
        parametro_id: "INFO_REALIZAR_REACTIVACION_ANTICIPADA",
        agrupacion: "TEXTO",
        auxiliar: "1",
      })
      .subscribe((resultado) => {
        if (!resultado?.result) return;

        const modalRef = this.modalService.open(ModalConfirmarRespuestaComponent, { centered: true });
        const confirmarRespuesta = {} as ConfirmarRespuestaModel;
        confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
        confirmarRespuesta.message = resultado.data;
        modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;

        modalRef.closed.subscribe(() => {
          this.realizarReactivacionAnticipada(rntPrestadorEntry);
        });
      });
  }

  private realizarReactivacionAnticipada(rntPrestadorEntry: RNTPrestadorModel): void {
    this.cargaPantalla = true;
    this.establecimientoComercioService.createReactivacionAnticipada(rntPrestadorEntry)
      .subscribe(response => {
        this.cargaPantalla = false;
        this.consultaTabla(1);
        if(!response?.result) return;
      })
  }

  getMensajeEliminacion(){
    let data = {
      parametro_id: "ADVERTENCIA_PST_ELIMINACION_SOLICITUD",
      agrupacion: "VALIDACIONES",
      auxiliar: "1"
    };

    this.establecimientoComercioService.getMensajeEliminacion(data).subscribe((response) => {
      this.mensajeEliminacion = response.data;
    });
  }
  validarSancionPersona(){
    this.sancionesPersonasService
        .validarSanciones()
        .subscribe( response => {
          if(response.result){
            this.puedeCrearRnt = response.data;
          }
        },error=>{

    });
  }
  getParam({parametro_id,agrupacion,auxiliar},hasAction: boolean): void{
    this.establecimientoComercioService
        .getParametro({
          parametro_id,
          agrupacion,
          auxiliar,
        })
          .subscribe(
            (resultado2) => {
              if (resultado2.result) {
                const modalAceptarRenovacion = this.modalService.open(
                  ModalValidarRenovacionComponent,
                  { centered: true, backdrop: "static", size: "md" }
                );
                modalAceptarRenovacion.componentInstance.mensaje =
                  resultado2.data;
              }
            },
            (error) => {
            }
          );
  }
}
